import DeltaWifiCitySelector from './DeltaWifiCitySelector';

export default DeltaWifiCitySelector;
